import { combineReducers } from '@reduxjs/toolkit';

import { inventoryLocationReducer } from '@sophocles/features/inventory/inventoryLocations';
//import { productReducer } from '@sophocles/features/inventory/products';
import { radioLocationReducer } from '@sophocles/features/inventory/radioLocations';

const inventoryReducer = combineReducers({
  inventoryLocations: inventoryLocationReducer,
  radioLocations: radioLocationReducer,
  //products: productReducer,
});

export default inventoryReducer;
